// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".rtm3yRpRXK4X0FDPiG4T{display:inline-block;vertical-align:middle;width:1em;height:1em}.rtm3yRpRXK4X0FDPiG4T,.d36TZzix6UY6Z5DgI5aY{contain:layout}.d36TZzix6UY6Z5DgI5aY{height:100%;width:100%;fill:currentColor;vertical-align:top}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "rtm3yRpRXK4X0FDPiG4T",
	"svg": "d36TZzix6UY6Z5DgI5aY"
};
module.exports = ___CSS_LOADER_EXPORT___;
